import { render, staticRenderFns } from "./TabelaCoparticipacao.vue?vue&type=template&id=0a7b91b5&scoped=true&"
import script from "./TabelaCoparticipacao.vue?vue&type=script&lang=js&"
export * from "./TabelaCoparticipacao.vue?vue&type=script&lang=js&"
import style0 from "./TabelaCoparticipacao.vue?vue&type=style&index=0&id=0a7b91b5&scoped=true&lang=css&"
import style1 from "./TabelaCoparticipacao.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a7b91b5",
  null
  
)

export default component.exports